module.exports = __webpack_public_path__ + "media/assets_v3/images/loading-animation-c39d5b4c3eb22428d1fbac0c15978056.svg";